<template>
  <div class="home_wrap">
    <!-- <van-nav-bar
        title="VIP"
        left-text=""
        left-arrow
        :fixed="true"
        @click-left="onClickLeft"
    /> -->

    <div class="vip_top">
      <div class="top_l">
        <div class="jiao">
          Nível Atual
        </div>
        <div class="vip_xx">
          <div class="vip_tb">
            <!-- <div class="cv">VIP{{ vip.vip_info.level }}</div> -->
            <div class="cv">
              <img
                :src="vip.vip_info.img"
                alt=""
              >
            </div>
          </div>
          <div class="vip_txt">
            <div>
              Restantes <span>VIP{{ vip.vip_info.next_level }}</span>
            </div>
            <div>Aposte Mais {{ vip.vip_info.need_bet }}</div>
            <div class="vip_je" />
          </div>
        </div>
      </div>
      <div class="top_r">
        <div class="an_hui">
          Resgatar<br>Tudo
        </div>
        <div
          class="an_huang"
          @click="$emit('toHis')"
        >
          Histórico
        </div>
      </div>
    </div>
    <div class="vip_title">
      <span>Lista De Níveis VIP</span>
      <button @click="getReward">
        Receber Premio
      </button>
    </div>
    <van-tabs
      v-model="active"
      class="van-tabs__wrap--scrollable"
      :sticky="true"
      :swipeable="true"
      :swipe-threshold="2"
      line-width="1.5rem"
      background="transparent"
      :color="'#fff0bb'"
      @change="tabChange"
    >
      <van-tab title="Bônus De Aumento De Nível" />
      <van-tab title="Bônus Semanal" />
      <van-tab title="Bônus Mensal" />
      <van-tab title="Privilégio VIP" />
    </van-tabs>
    <div class="vip_con">
      <table width="100%">
        <thead>
          <tr class="g_top">
            <td
              v-for="(item, index) in listHear"
              :key="index"
              :class="
                vip.vip_info.level == 0 ? 'table_td borderNone' : 'table_td'
              "
            >
              {{ item }}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in vip.vip_list"
            :key="index"
            class="g_row0"
            :class="item.is_achieved ? 'active' : ''"
          >
            <td>
              <img
                :src="item.img"
                alt=""
              >
            </td>
            <td v-if="active == 0">
              {{ item.bet_amount }}
            </td>
            <!-- 投注晋级 -->

            <td
              v-if="active == 0"
              class="huang"
            >
              R${{ item.level_reward }}
            </td>
            <td v-if="active == 1">
              {{ item.week_reward }}
            </td>
            <td v-if="active == 2">
              {{ item.month_reward }}
            </td>
            <td v-if="active == 1 || active == 2">
              {{ item.bet_amount }}
            </td>
            <td v-if="active == 3">
              {{ item.withdraw_amount }}
            </td>
            <td v-if="active == 3">
              {{ item.withdraw_times }}
            </td>


            <!-- <td class="huang" v-if="active == 1">R${{ item.level_reward }}</td> -->

            <!-- <td class="huang">{{ item.withdraw_times }}</td>
            <td class="huang">R${{ item.withdraw_amount }}</td> -->
            <!-- <td >
            <button v-if="item.is_get == 1" @click="getVipMoney(item.bet_amount)" class="get_money">Receber</button>
            <button v-if="item.is_get == 0"  class="descomprometido">descomprometido</button>
            <button v-if="item.is_get == 2"  class="descomprometido">Recebido</button>
          </td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { NavBar, Tab, Tabs } from "vant";
import Fetch from "../../utils/fetch";
Vue.use(NavBar).use(Tab).use(Tabs);
export default {
  name: "Vip",
  components: {},
  data() {
    return {
      next_level: 0,
      listHear: ["Nível", "Aposta Para Promoção", "Bônus De Aumento De Nível"],
      vip: {
        vip_info: { next_level: 0 },
        vip_list: [],
      },
      active: 0,
    };
  },
  created() {},
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch("/user/vip_config_list").then((r) => {
        this.vip = r.data;
        this.next_level = r.data.vip_info.next_level;
      });
    },
    getReward() {
      Fetch("/user/addVipBetReward").then((r) => {
        if (r.code == 1) {
          this.$message.success(r.msg);
        } else {
          this.$message.error(r.msg);
        }
      });
    },
    getVipMoney(bet_amount) {
      Fetch("/user/addVipBetReward", { bet_amount }).then((r) => {
        if (r.code == 1) {
          this.$message.success({
            title: r.msg,
          });
          setTimeout(() => {
            this.$router.go(0);
          }, 1000);
        } else {
          this.$message.error({
            title: r.msg,
          });
        }
      });
    },
    onClickLeft() {
      this.$router.push("/activity");
    },
    tabChange(v) {
      this.active = v;
      if (v == 1) {
        this.listHear = [
          "Nível",
          "aposta total",
          "Bônus",
        ];
      } else if (v == 2) {
        this.listHear = [
          "Nível",
          "aposta total",
          "Bônus",
        ];
      } else if (v == 0) {
        this.listHear = [
          "Nível",
          "Aposta Para Promoção",
          "Bônus De Aumento De Nível",
        ];
      } else if (v == 3) {
        this.listHear = [
          "Nível",
          "O Valor Total Da Retirada Diária",
          "O Limite Superior Da Retirada Diária",
        ];
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar {
  background: @primary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: @textcolor1;
}

/deep/ .van-nav-bar__title {
  color: @textcolor1;
}
/deep/ .van-tabs__nav .van-tab--active span {
  color: @ButtonColor!important;
}
.cv {
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-size: 0.5rem;
  margin-top: -0.5rem;
  //background: #fc661e;
  border-radius: 50%;
  color: #fff;
}
.get_money {
  background-color: #fc661e;
  border: none;
  padding: 0.1rem 0.2rem;
  border-radius: 0.1rem;
}
.descomprometido {
  border: none;
  padding: 0.1rem 0.2rem;
  border-radius: 0.1rem;
  background: none;
}
table {
  border-collapse: collapse;
}
.home_wrap {
  width: 100%;
  min-height: 100vh;
  //background-color: rgb(48, 48, 48);
  // padding-top: 1.5rem;
  // background-color: @activityColor;
  padding-bottom: 1.5rem;
}
.table_td:first-child {
  border-left: 0.01rem solid @bodercolor;
  border-top: 0.01rem solid @bodercolor;
  border-bottom: 0.01rem solid @bodercolor;
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
  padding: 0.2rem;
}
.table_td:last-child {
  border-right: 0.01rem solid @bodercolor;
  border-top: 0.01rem solid @bodercolor;
  border-bottom: 0.01rem solid @bodercolor;
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}
.table_td:not(:last-child)::before {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 1.6em;
  background-color: @bodercolor;
  transform: translateY(-50%);
  transition: background-color 0.3s;
  content: "";
}
.borderNone {
  border-bottom: none !important;
}
.vip_title {
  color: @textcolor1;
  font-size: 0.4rem;
  margin-left: 0.4rem;
  margin-top: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  button {
    border: none;
    background: @ButtonColor;
    color: @textcolorf;
    font-size: 11px;
    padding: 4px 10px;
    border-radius: 8px;
    margin-right: 16px;
  }
}
.vip_top {
  width: 95%;
  display: flex;
  border-radius: 0.2rem;
  margin: 0.2rem auto 0 auto;
  background-color: @primary-color;
  padding-bottom: 0.2rem;
  border-radius: 12px;
  border: 2px solid @ButtonColor;
  box-shadow: 0 .3125rem .3125rem rgba(0, 0, 0, .08), inset 0 0 .09375rem .09375rem @ButtonColor !important;
  .top_l {
    width: 80%;
    .jiao {
      width: 1.4rem;
      height: 0.4rem;
      line-height: 0.4rem;
      font-size: 0.24rem;
      text-align: center;
      border-radius: 0.05rem 0.05rem 0.05rem 0;
      background: @jiaoColor;
      color: #fff;
    }
    .vip_xx {
      display: flex;
      color: @textcolor1;
      margin: 0.2rem;
      .vip_tb {
        position: relative;
        width: 1.2rem;
        img {
          width: 100%;
        }
      }
      .vip_txt {
        margin-left: 2%;
        p {
          line-height: 0.38rem;
        }
        span {
          color: #fee000;
          font-style: italic;
        }
        .vip_je {
          font-size: 0.35rem;
        }
      }
    }
  }
  .top_r {
    width: 17%;
    font-size: 0.28rem;
    text-align: center;
    margin: 0.2rem 0.2rem 0 0;
    .an_hui {
      width: 100%;
      color: #fff;
      background-color: #999;
      height: 0.7rem;
      border-radius: 0.14rem;
      padding-top: 0.1rem;
    }
    .an_huang {
      width: 100%;
      background: @ButtonColor;
      color: @primary-color;
      height: 0.7rem;
      border-radius: 0.14rem;
      padding-top: 0.06rem;
      margin-top: 0.2rem;
      line-height: 0.7rem;
    }
  }
}
.table_td {
  border-top: 0.01rem solid @bodercolor;
  border-bottom: 0.01rem solid @bodercolor;
  height: 1.1rem;
  font-size: 0.3rem;
  position: relative;
}
.vip_con table {
  width: 95%;
  margin: 0.6rem auto 0 auto;
  text-align: center;
  th {
    border-radius: 0.2rem;
  }
  .g_top {
    //border: 1px solid #293548;
    color: @textcolor1;
    .top_apo {
      display: flex;
      text-align: center;
      justify-content: center;
      a {
        display: block;
        width: 0.3rem;
        height: 0.3rem;
        line-height: 0.3rem;
        border-radius: 50%;
        color: rgb(14, 19, 27);
        margin: 0.5rem 0 0 0.1rem;
        background-color: #cdb48f;
      }
    }
  }

  .g_row0 {
    height: 1.3rem;
    color: @messageTextColor;
  }
  .g_row0:first-child {
    margin-top: 0.1rem;
  }
  .g_row0:nth-child(odd) {
    background-color: @secondary-color;
  }
  .g_row0:nth-child(even) {
    background-color: @activityColor;
  }
  .active {
    // background-color: @primary-color !important;
    border: 0.01rem solid @rechargeColor;
    border-radius: 0.1rem;
  }
  .g_row1 {
    height: 1.3rem;
    color: #e3e3e3;
    .jindu {
      width: 80%;
      margin: 0.1rem auto 0 auto;
      height: 0.36rem;
      line-height: 0.36rem;
      font-size: 0.28rem;
      border-radius: 0.2rem;
      background-color: #777777;
    }
  }
  .g_row2 {
    height: 1.3rem;
    color: #e3e3e3;
    background-color: rgb(14, 19, 27);
  }
  img {
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 50%;
  }
  .huang {
    color: #e5c616;
  }
}
</style>